<template>
  <bm-control v-bind="$attrs" :read-only-value="value">
    <template #default="{ dataQa }">
      <v-textarea
        class="bm-text"
        :persistent-hint="true"
        :placeholder="placeholderVal"
        :value="value"
        v-bind="$attrs"
        color="brand02"
        :label="undefined"
        :data-qa="dataQa"
        :data-component="dataComponent"
        auto-grow
        :rows="1"
        @input="emit('update:value', $event)"
        @focus="emit('focus', $event)"
        @blur="blurEvent($event)"
        @keydown="emit('keydown', $event)"
        @mousedown="emit('mousedown', $event)"
        @touchstart="emit('touchstart', $event)"
      >
      </v-textarea>
    </template>
  </bm-control>
</template>

<script setup lang="ts">
import BmControl from "@/components/controls/input/BmControl.vue";
import { computed } from "vue";
import dataComponentAttrs from "@/components/controls/DataComponentAttrs";

interface Props {
  autoTrim?: boolean;
  value?: string;
  placeholder?: string;
}

interface Events {
  (event: "update:value", value: string): void;
  (event: "focus", e: Event): void;
  (event: "blur", e: Event): void;
  (event: "keydown", e: Event): void;
  (event: "mousedown", e: Event): void;
  (event: "touchstart", e: Event): void;
}

const props = withDefaults(defineProps<Props>(), {
  autoTrim: true,
});

const emit = defineEmits<Events>();

const dataComponent = dataComponentAttrs.bmTextArea;

// This is ugly, but it makes all v-text-field controls think they have a placeholder.
// Which in turn causes the label to render above the field.
const placeholderVal = computed(() => {
  if (!props.placeholder) {
    return " ";
  }

  return props.placeholder;
});

/**
 * Auto trim on blur (if desired)
 */
const blurEvent = (event: FocusEvent) => {
  if (props.autoTrim && props.value && props.value.trim() !== props.value) {
    emit("update:value", props.value.trim());
  }

  emit("blur", event);
};
</script>

<style lang="sass">
@import "src/sass/typography"

.bm-label
  @include bm-field-label

.bm-text
  @include bm-field
</style>
